import type { INotification } from '$src/types/notifications.type';
import { api } from './index'

export const getNotifications = async (userId: string, limit = 10, skip = 0) => {
  if (!userId) {
    return [];
  }
  return await api
    .get(`/notification/user/${userId}?limit=${limit}&skip=${skip}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data.notifications as INotification[];
    });
};

export const deleteNotification = async (notificationId: string) => {
  return await api
    .delete(`/notification/${notificationId}`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data;
    });
};

export const deleteAllNotifications = async () => {
  return await api
    .put(`/notification/all`, {
      headers: {
        'cache-control': 'public, max-age=3600'
      }
    })
    .then(res => {
      return res.data;
    });
};

export const getAllScheduledNotification = async () => {
  return await api.get(`/notification/scheduled`, {}).then(res => {
    return res.data;
  });
};
